import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/store';
import Card from '../../ui/Card';
import { formatCurrency } from '../../../utils/formatters';

const SalesChart: React.FC = () => {
  const { t } = useTranslation();
  const { sales } = useSelector((state: RootState) => state.sales);

  const monthlySales = sales.reduce((acc: Record<string, { total: number; count: number }>, sale) => {
    const month = new Date(sale.sale_date).toLocaleString('default', { month: 'long' });
    if (!acc[month]) {
      acc[month] = { total: 0, count: 0 };
    }
    acc[month].total += sale.total_amount;
    acc[month].count += 1;
    return acc;
  }, {});

  const maxTotal = Math.max(...Object.values(monthlySales).map(data => data.total), 0);

  return (
    <Card>
      <h3 className="text-lg font-semibold mb-4">{t('sales.analytics')}</h3>
      <div className="space-y-4">
        {Object.entries(monthlySales).length === 0 ? (
          <p className="text-gray-500 text-center py-4">{t('sales.noSales')}</p>
        ) : (
          Object.entries(monthlySales).map(([month, data]) => (
            <div key={month} className="space-y-1">
              <div className="flex justify-between text-sm">
                <span>{month}</span>
                <span>{formatCurrency(data.total)}</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-green-600 h-2 rounded-full"
                  style={{ width: `${maxTotal ? (data.total / maxTotal) * 100 : 0}%` }}
                />
              </div>
              <p className="text-xs text-gray-500">{data.count} {t('sales.title').toLowerCase()}</p>
            </div>
          ))
        )}
      </div>
    </Card>
  );
};

export default SalesChart;